import { registerBlockPlugin } from '../../core/BlockPluginRegistry';
import type { BlockPlugin } from '../../core/types';
import type { CostEstimateData } from '../../directives/components/CostEstimateForm';
import { createDefaultCostEstimateData } from '../../directives/utils/costEstimateUtils';
import { CostEstimateBlockView } from './CostEstimateBlockView';

export const costEstimatePlugin: BlockPlugin<CostEstimateData> = {
    name: 'costEstimate',
    displayName: 'Cost Estimate',
    hasData: true,
    defaultData: () => createDefaultCostEstimateData([], undefined),
    Component: CostEstimateBlockView
    // toolbarInsert handled as extraAction in ToolbarInserts (needs API data + surrounding markdown)
};

registerBlockPlugin(costEstimatePlugin);
